function get(url) {
    return new Promise((resolve) => {
        var xhr = new XMLHttpRequest();
        xhr.open('GET', url, false);
        xhr.onreadystatechange = function() {
            // readyState == 4说明请求已完成
            if (xhr.readyState == 4 && xhr.status == 200) {
                // 从服务器获得数据
                let data = JSON.parse(xhr.responseText);
                resolve(data)
            }
        };
        xhr.send();
    })
}
function post(url,obj){
    return new Promise((resolve)=>{
        //obj = formatParams(obj)
        var xhr = new XMLHttpRequest();
        xhr.open('POST',url,false);
        //xhr.setRequestHeader('content-type','application/json;charset=UTF-8');
        xhr.onreadystatechange = function() {
            if (xhr.readyState == 4 && xhr.status == 200) {
                let data = JSON.parse(xhr.responseText)
                resolve(data)
            }
        };
        xhr.send(obj)
    })
}
let $http = {get:get,post:post}
module.exports = $http;